import { loc } from '@/localization';

import { MessagePage } from './message';

export function CancelledPage() {
    return <MessagePage message={loc.Login.RestorePasswordCancelled} />;
}
